/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './work-flow-protocol.reducer';

export const WorkFlowProtocolDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const workFlowProtocolEntity = useAppSelector(state => state.workFlowProtocol.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="workFlowProtocolDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.workFlowProtocol.detail.title">WorkFlowProtocol</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocol.id">Id</Translate>
            </span>
          </dt>
          <dd>{workFlowProtocolEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocol.name">Name</Translate>
            </span>
            <UncontrolledTooltip target="name">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocol.help.name" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowProtocolEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocol.description">Description</Translate>
            </span>
            <UncontrolledTooltip target="description">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocol.help.description" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowProtocolEntity.description}</dd>
          <dt>
            <span id="tenantId">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocol.tenantId">Tenant Id</Translate>
            </span>
            <UncontrolledTooltip target="tenantId">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocol.help.tenantId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowProtocolEntity.tenantId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocol.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocol.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowProtocolEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocol.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocol.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowProtocolEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocol.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocol.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowProtocolEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocol.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocol.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowProtocolEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocol.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.workFlowProtocol.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{workFlowProtocolEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.workFlowProtocol.tenantType">Tenant Type</Translate>
          </dt>
          <dd>{workFlowProtocolEntity.tenantType ? workFlowProtocolEntity.tenantType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.workFlowProtocol.encounterType">Encounter Type</Translate>
          </dt>
          <dd>{workFlowProtocolEntity.encounterType ? workFlowProtocolEntity.encounterType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.workFlowProtocol.protocolType">Protocol Type</Translate>
          </dt>
          <dd>{workFlowProtocolEntity.protocolType ? workFlowProtocolEntity.protocolType.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/work-flow-protocol" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/work-flow-protocol/${workFlowProtocolEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default WorkFlowProtocolDetail;
